<template>
  <div class="">
    <el-input placeholder="列表只列出最近5條交易訂單，更多可輸入交易編號進行檢索" clearable v-model="condition" @input="getdata"></el-input>
    <div class="mb15"></div>
    <el-table :data="deallist" border :header-cell-style="{background:'#FAFAFA'}" ref="multipleTable" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column width="120" property="businessnum" label="交易編號">
        <template slot-scope="scope">
          <div class="phonecel">交易編號</div>
          <span :class="{'unlink':scope.row.status==5}">S{{scope.row.businessnum}}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" property="addtime" label="時間">
        <template slot-scope="scope">
          <div class="phonecel">時間</div>
          <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" property="account" label="交易賬戶">
        <template slot-scope="scope">
          <div class="phonecel">交易賬戶</div>
          <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
          <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
            <div v-if="scope.row.bank_account.id">
              <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
              <div>{{scope.row.bank_account.bankname}} </div>
              <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
            </div>
            <div v-else>
              未關聯賬戶
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="出款貨幣">
        <template slot-scope="scope">
          <div class="phonecel">出款貨幣</div>
          <span :class="{'unlink':scope.row.status==5}">
            {{scope.row.currency_short_name}}
            {{tomoney(scope.row.money)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column property="status" label="狀態">
        <template slot-scope="scope">
          <div class="phonecel">狀態</div>
          <statustext :status="scope.row.status"></statustext>
        </template>
      </el-table-column>
      <el-table-column property="file" label="水單">
        <template slot-scope="scope">
          <div class="phonecel">水單</div>
          <div v-if="scope.row.files.length>0" class="flex">
            <img :src="apiurl+scope.row.files[0].fileurl" height="35px" class="mr10" @click="showimg_url=apiurl+scope.row.files[0].fileurl;showimg_dialog = true;">
            <el-link v-if="scope.row.files.length>1" @click="Details(scope.row.id)">還有{{scope.row.files.length-1}}張</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-button @click="getResult()">選好了</el-button>
      <el-button @click="toggleSelection()">取消選擇</el-button>
    </div>
    <!-- 水單查看 -->
    <el-dialog :visible.sync="showimg_dialog" height="80%" center :append-to-body="true">
      <img :src="showimg_url" alt="" style="width:100%;margin:0 auto;">
    </el-dialog>
  </div>
</template>

<script>
import statustext from "@/components/StatusText.vue";
export default {
  components: {
    statustext
  },
  name: "sellbusienesAssoclate",
  props: ['order_id', 'is_linker'],
  data () {
    return {
      multipleSelection: [],
      deallist: [],
      condition: '',
      showimg_url: '',
      showimg_dialog: false,
    }
  },
  methods: {
    getdata () {
      this.post('/api/business/sell_assoclate', {
        type: -1,
        buytype: 1,
        condition: this.condition
      }).then((res) => {
        this.deallist = res;
      }).catch((err) => {

        console.log(err)
      })
    },
    toggleSelection () {
      this.$refs.multipleTable.clearSelection();
    },
    getResult () {
      if (this.multipleSelection.length > 0) {
        let ids = [];
        this.multipleSelection.map(item => {
          ids.push(item.id);
        });
        let order_id = this.order_id;
        let is_linker = this.is_linker;
        // console.log(this.is_linker);
        let mso_id = sessionStorage.getItem('mso_id');
        let staff_id = sessionStorage.getItem('staff_id');
        if (order_id == 0) {
          this.$emit('getids', ids);
          this.$emit('update:visible', false);
        } else {
          this.post('/api/order/association', { ids, order_id, mso_id, staff_id, is_linker })
            .then(response => {
              if (response == 'success') {
                this.$emit('reload');
                this.$message({
                  showClose: true,
                  message: '選擇成功',
                  type: 'success',
                  onClose: (() => {
                  })
                })
                this.$emit('update:visible', false);
              } else {
                this.$message({
                  showClose: true,
                  message: '選擇失敗',
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            })
        }


      }

    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    init () {
      this.multipleSelection = this.selection;
    }
  },
  created () {
    this.getdata();
  }
}
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
